import React, { useState, useEffect } from 'react';
import { Button } from "primereact/button";
import * as request from "../admin/lib/lib";
import { Dialog } from "primereact/dialog";

export function Rules() {

    const [rulesData, setRulesData] = useState([]);

    const [visible, setVisible] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);


    const openPdf = (file) => {
        setSelectedFile(file);
        setVisible(true);
    };

    //console.log('test')
    useEffect(() => {
        const populateRules = async () => {
            try {
                const response = await request.get(process.env.REACT_APP_BACKEND_URL + 'GetInfo/Rules');
                //const jsonData = await response.json();

                setRulesData(response.rules);
                //setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error );
            }
        };

        populateRules();

        document.title = `Наредби`;
    }, []); // The empty dependency array means this effect runs once, equivalent to componentDidMount.

    return (
        <div>
            <div>
                <div className="title_news mt-4 mb-5">Правила за прием и нормативна уредба</div>
                {rulesData.length == 0 ? (
                    <p>...</p>
                ) : (
                    rulesData.map((rd, index) => (
                        <div className="t_news m-news-mob w-100-mob color-bg-cl" key={index}>
                            <p></p>
                            <div>
                                <Button
                                    key={index}
                                    label={rd.title}
                                    icon="pi pi-file-pdf"
                                    className={`p-button-text ${selectedFile?.url === rd.link ? "p-button-danger" : ""
                                        }`}
                                    pt={{
                                        label: { className: "rules-btn-label" },
                                        icon: { className: "rules-btn-label" },
                                    }}
                                    onClick={() => openPdf(rd)}
                                />
                                {/*<a href={`documents/rules/${rd.link}`} target="_blank" rel="noopener noreferrer">
                                    <div className="text-news">{rd.title}</div>
                                </a>*/}
                            </div>
                        </div>
                    ))
                )}
            </div>

            <Dialog
                header={selectedFile ? selectedFile.title : "Преглед на наредба"}
                visible={visible}
                style={{ width: "90vw", maxWidth: "1200px" }}
                onHide={() => setVisible(false)}
                maximizable
                modal
            >
                {selectedFile ? (
                    <object
                        data={`documents/rules/${selectedFile.link}`}
                        type="application/pdf"
                        width="100%"
                        height="800px"
                    >
                        <p>
                            Вашият браузър не поддържа PDF визуализация.{" "}
                            <a
                                href={`documents/rules/${selectedFile.link}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Изтегли PDF
                            </a>
                            .
                        </p>
                    </object>
                ) : (
                    <p>Изберете наредба от списъка, за да я прегледате.</p>
                )}
            </Dialog>

        </div>
    );
}

export default Rules;